<template>
  <div>
    <div v-if="images.length>0">
      <g-swiper :images="images"></g-swiper>
    </div>
    <div class="c-m-20">
      <div class="c-fl-bt c-p-tb-20">
        <div class="c-main-txt">{{datas.Name}}</div>
        <div class='star'>
          <g-star num="5"></g-star>
        </div>
      </div>
      <van-cell :title="getTime()" class="c-m-tb-10 c-b-s c-b-r-16">
        <template #icon>

          
          <g-img
            size="20"
            :src="require('@/assets/images/ticketTime.png')"
            class="c-p-r-20 c-fl-bt c-p-b-6"
          ></g-img>
        </template>
      </van-cell>
      <van-cell
        :title="datas.Phone"
        class="c-m-tb-10 c-b-s c-b-r-16"
        is-link
        @click="$pub.toTel(datas.Phone)"
      >
        <template #icon>
          <g-img
            size="20"
            :src="require('@/assets/images/ticketPhone.png')"
            class="c-p-r-20 c-fl-bt c-p-b-6"
          ></g-img>
        </template>
      </van-cell>
      <van-cell
        :title="aa(datas.Address, datas.Name)"
        class="c-m-tb-10 c-b-s c-b-r-16"
        is-link
        @click="toAddress(datas)"
      >
        <template #icon>
          <g-img
            size="20"
            :src="require('@/assets/images/ticketAddress.png')"
            class="c-p-r-20 c-fl-bt c-p-b-6"
          ></g-img>
        </template>
      </van-cell>
    </div>
    <!-- .storeMap(v-if="storeLongitude && storeLatitude")
      #storeMap -->
    <div
      class="storeMap "
      v-if="datas.Longitude && datas.Latitude"
    >
      <div id="storeMap"></div>
    </div>

  </div>
</template>

<script>
import wxConfig from '@/utils/wxConfig.js'
export default {
  name: "DoorDetail",
  props: {

  },
  data() {
    return {
      id: '',
      datas: {},
      images: [],
    };
  },
  created() {
    // this.mapInit();
    this.init();

  },
  mounted() {

  },
  methods: {
    aa(addr, name) {
      let res = `${addr}(${name})`
      return res;
    },
    init() {
      this.id = this.$route.query.id;
      $http(`wechath5/zh-cn/v1/vpn/${this.id}`).then(res => {
        this.datas = res;
        if (res.Claims.length !== 0) {
          this.images = res.Claims.filter(v => {
            return v.TypeId === 2;
          }).map(v => {
            let str = '';
            str += v.CdnUrl + '/' + v.Value;
            return str;
          })
        }
        this.$nextTick(() => {
          this.mapInit();
        })
      })
    },
    mapInit() {
      let { datas } = this;
      if (!datas.Latitude || !datas.Longitude) {
        return;
      }
      var myLatlng = new qq.maps.LatLng(datas.Latitude, datas.Longitude);// 设置地图中心点
      // 地图参数配置
      var myOptions = {
        zoom: 12, // 设置地图缩放级别
        draggable: false, // 禁止拖拽地图
        center: myLatlng,
        mapTypeId: qq.maps.MapTypeId.ROADMAP, // 设置地图样式详情参见MapType
        zoomControl: true, // 启用缩放控件
        zoomControlOptions: {// 设置缩放控件的样式
          // 设置缩放控件样式为默认的缩放控件。会根据地图尺寸的大小和其他因素自动调整样式
          style: qq.maps.ZoomControlStyle.DEFAULT
        }
      };
      var map = new qq.maps.Map(document.getElementById('storeMap'), myOptions);// 获取dom元素添加地图信息
      // 创建marker
      var marker = new qq.maps.Marker({
        position: myLatlng,
        map: map,
        animation: qq.maps.MarkerAnimation.BOUNCE// 设置Marker被添加到Map上时的动画效果为反复弹跳
      });
      // 添加信息窗口
      var infoWin = new qq.maps.InfoWindow({
        map: map
      });
      // open()打开信息窗口
      infoWin.open();
      infoWin.setPosition(map.getCenter());
      // close()关闭信息窗口
      setTimeout(function() {
        infoWin.close();
      }, 10 * 1000);
      // setContent()设置信息窗口显示区的内容
      infoWin.setContent('<div>' + datas.Address + '欢迎您！</div>');
    },

    toAddress(v) {
      if (v.Latitude && v.Longitude && v.Name && v.Address) {
        wxConfig.consultMap(this, v.Latitude, v.Longitude, v.Name, v.Address);
      } else {
        this.$toast('请在后台完善经纬度等信息')
      }
    },
    getTime() {
      return this.datas.BusinessStartTime + ' -- ' + this.datas.BusinessEndTime;
    }
  }
};
</script>
<style scoped lang='scss'>
.storeMap {
  width: 682px;
  height: 282px;
  margin: 20px auto 20px;
}

#storeMap {
  width: 100%;
  height: 100%;
}
</style>
